import { Theme } from 'styles/theme';

type Row = {
  valueA?: any;
  valueB?: any;
};

function normalizeValue(value: unknown): string | undefined | null {
  if (typeof value !== 'string') return value as any;
  const cleaned = value.replace(/[\x00-\x1F\x7F-\x9F\u200B-\u200D\uFEFF]/g, '').trim();
  if (/^<p>\s*<\/p>$/i.test(cleaned)) return null;

  return cleaned.length > 0 ? cleaned : null;
}

function getLeftRowColor(row: Row, theme: Theme) {
  const a = normalizeValue(row.valueA);
  const b = normalizeValue(row.valueB);

  if (!a && b) return theme.colors.elementsInputBorder;
  if (a && !b) return theme.colors.statusLabelRedBg;
  if (a !== b) return theme.colors.statusLabelRedBg;
  return undefined;
}

function getRightRowColor(row: Row, theme: Theme) {
  const a = normalizeValue(row.valueA);
  const b = normalizeValue(row.valueB);

  if (!a && b) return theme.colors.elementsInputBorder;
  if (a && !b) return theme.colors.secondaryLightGreen;
  if (a !== b) return theme.colors.secondaryLightGreen;
  return undefined;
}

export function getRowColor(
  isLeft: boolean,
  row: Row,
  theme: Theme
): import('csstype').Property.BackgroundColor | undefined {
  return isLeft ? getLeftRowColor(row, theme) : getRightRowColor(row, theme);
}
